import Select from "./Select";
import Input from "./Input";
import { useTranslation } from "react-i18next";

/**
 * Composant des formulaires de l'ECP
 * @param {function} handleSubmit - fonction de soumission de React Hook Form
 * @param {function} mutate - provenant de useQuery, pour modifier les données et effectuer un nouveau fetch
 * @param {function} onInvalid - gestion des erreurs du formulaire
 * @param {function} register - provenant de React Hook Form
 * @param {boolean} isError - état d'erreur provenant de useQuery
 * @param {array} errors - erreurs du formulaire provenant de React Hook Form
 * @param {object} error - erreur renvoyée par la requête useQuery
 * @param {function} formData - données du formulaire
 * @param {function} action - action définie par le formulaire : (create, update ou delete)
 */

export default function MultipleForm({
  handleSubmit,
  mutate,
  onInvalid,
  register,
  formData,
  isError,
  errors,
  error,
  action,
  title
}) {
  const { t } = useTranslation();
  return (
    <form className="form" onSubmit={handleSubmit(mutate, onInvalid)}>
      <h2 className="dialog-form-title">{t(title)}</h2>
      <div className="form-content-items">
        {formData.length > 0 &&
          formData.map((item) => {
            return (
              <div className="form-input_container" key={item.id}>
                <label htmlFor={item.id}>{t(item.title)}</label>
                {item.type === "select" && item !== undefined ? (
                  <Select
                    item={item}
                    register={register}
                  />
                ) : (
                  <Input item={item} register={register} />
                )}
                {errors[item.id] && (
                  <small className="error">{t(errors[item.id].message)}</small>
                )}
              </div>
            );
          })}
      </div>
      <button className="button button-new">
        {action === "new"
          ? t("Créer")
          : action === "update"
            ? t("Modifier")
            : t("Supprimer")}
      </button>
      {isError ? <small className="error">{t(error?.message)}</small> : null}
    </form>
  );
}
